import React from 'react'
import PropTypes from 'prop-types'
import { Typography, Toast } from '@chilecompra/react-kit'

import { PATH_PARAM } from '../../config/settings/regexes'
import routes from '../../config/settings/routes'
import { LinkInternal, Strong } from './PartnershipGridSection.styles'

/**
 * The NotPublicPartnershipMessage component.
 */
const NotPublicPartnershipMessage = ({ dni, hasAffidavit, isForcedAffidavit, partnershipCount }) => {
  if (!hasAffidavit) {
    return (
      <Typography color="black3" fontWeight="regular" margin="18px 0" variant="body2">
        Debido a que la empresa proveedora no cuenta con su Declaración Jurada del Registro de Proveedores firmada, no
        hay información disponible sobre Socios y accionistas de la empresa.
      </Typography>
    )
  }

  if (isForcedAffidavit) {
    return (
      <Toast margin="18px 0 0" severity="info">
        La información de socios y accionistas se muestra para todas las empresas proveedoras que hayan realizado su
        Declaración Jurada del Registro de Proveedores a través del sistema. En caso que la declaración haya sido
        realizada de forma manual, podrías encontrar dicha información en la sección{' '}
        <LinkInternal to={routes.documents.replace(PATH_PARAM, dni)}>Documentos</LinkInternal>.
      </Toast>
    )
  }

  if (partnershipCount === 0) {
    return (
      <Typography color="black3" fontWeight="regular" margin="18px 0" variant="body2">
        Esta empresa proveedora <Strong>no posee</Strong> socios y accionistas.
      </Typography>
    )
  }

  return null
}

NotPublicPartnershipMessage.propTypes = {
  dni: PropTypes.string.isRequired,
  hasAffidavit: PropTypes.bool.isRequired,
  isForcedAffidavit: PropTypes.bool.isRequired,
  partnershipCount: PropTypes.number.isRequired
}

export default NotPublicPartnershipMessage
